import { render, staticRenderFns } from "./header-bar.vue?vue&type=template&id=452789c9&scoped=true&"
import script from "./header-bar.vue?vue&type=script&lang=js&"
export * from "./header-bar.vue?vue&type=script&lang=js&"
import style0 from "./header-bar.vue?vue&type=style&index=0&id=452789c9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452789c9",
  null
  
)

export default component.exports